export const validateZipcode = (zipcode: string) => {
  const zipCodeRegex = /^\d{5}(-\d{4})?$/;
  return zipCodeRegex.test(zipcode);
};
